import axios from 'axios';
import { AUTH_CONFIG } from './Auth/auth0-variables';

// A stale/invalid access token (e.g. left over in localStorage from another
// session) passes isAuthenticated()'s client-side expiry check but gets
// rejected by the backend. Without this, the app gets stuck: it never shows
// the login screen again, it just keeps re-sending the same bad token.
// Clearing the session on 401 forces componentDidMount back onto the
// login/silent-auth path, so this can't loop.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

const testClients = ['ALW', 'BRB', 'CLS'];

const range = len => {
  const arr = [];
  for (let i = 0; i < len; i++) {
    arr.push(i);
  }
  return arr;
};

const clientUser = (client_id) => {
  return {
    client_id: client_id
  }
}

export function parseClient(groups) {
  for (let g in groups) {
    var res = groups[g].match(/Rejections/);
    if (res) {
      res = res.input.split(' ');
      if (res[0] === 'AMQ') res[0] = 'AMI';
      return res[0];
    }
  }
}

export function makeData(len = testClients.length) {
  return range(len).map(d => {
    return {
      ...clientUser(testClients[d]),
    };
  });
}

export function assignAccess(client_id) {
  if (client_id === 'SKY') return true;
  else return false;
}

export function loadClients() {

  axios.get('http://localhost:5001/test')
    .then((response) => {

    })
    .catch((error) => {
      console.log(error);
    })

  return "Success?"

}

export function getClients(accessToken) {
  var clients = [];
  return axios.get(AUTH_CONFIG.baseUrl + '/clients', {
    headers : {
      Authorization : "Bearer " + accessToken
    }
  }).then((response) => {

    var data = response.data;
    console.log(data);
    Object.keys(data).forEach(key => {
      clients.push({value:key, label:data[key]});
    });
    // for (var i = 0; i < data.length - 3; i += 3) {
    //   clients.push(data.slice(i, i+3))}
    return clients;
  }).catch((error) => {
    console.log(error);
  })

}

export function getRates(client_id_param, accessToken) {
  var rates = [];
  var dataList = [];
  return axios.get(AUTH_CONFIG.baseUrl + '/rates' ,{
  //return axios.get('http://192.168.100.164:5000/rates',{
    headers : {
      Authorization : "Bearer " + accessToken
    },
    //responseType: 'text',
    params: {
      client_id : client_id_param
    }
  }).then((response) => {
    dataList = response.data.split(" ").join().split(",");
    for(var i = 0;i <= dataList.length - 4; i += 5){

      rates[dataList[i]] = dataList[i+1]+','+dataList[i+2]+','+dataList[i+3]+','+dataList[i+4];
    }
    return rates;
  }).catch((error) => {
    console.log(error);
  });
}

export function getConfig(accessToken) {
  var rates = [];
  var dataList = [];
  return axios.get(AUTH_CONFIG.baseUrl + '/config' ,{
  //return axios.get('http://192.168.100.164:5000/rates',{
    headers : {
      Authorization : "Bearer " + accessToken
    },
    //responseType: 'text',

  }).then((response) => {
    dataList = response.data.split(" ").join().split(",");
    for(var i = 0;i <= dataList.length - 4; i += 5){

      rates[dataList[i]] = dataList[i+1]+','+dataList[i+2]+','+dataList[i+3]+','+dataList[i+4];
    }
    return rates;
  }).catch((error) => {
    console.log(error);
  });
}

export function getCurrencyList(accessToken) {
  return axios.get(AUTH_CONFIG.baseUrl + '/currency' ,{
  //return axios.get('http://192.168.100.164:5000/rates',{
    headers : {
      Authorization : "Bearer " + accessToken
    },
  }).then((response) => {
    return response;
  }).catch((error) => {
    console.log(error);
  });
}

export function getRates_Test(client_id_param) {
  //var rates = [];
  //var dataList = [];
  return fetch(AUTH_CONFIG.baseUrl + '/rates',{
    params:{
      client_id : client_id_param
    }
  }).then(response => {
    response.json();
  }).then(data => {

  });
}



export function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.lenght < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}
